export default class EventData
{
	getEvent ()
	{
		return this.event;
	}

	setEvent (v)
	{
		this.event = v;
		return this;
	}

	getAction ()
	{
		return this.action;
	}

	setAction (v)
	{
		this.action = v;
		return this;
	}

	getName ()
	{
		return this.name;
	}

	setName(v)
	{
		this.name = v;
		return this;
	}
}
